import { useAuiState } from "../aui";

/** The thread the AgentRuntime around this component shows, or null before it has one. */
export function useThreadId(): number | null {
  const id = Number(useAuiState((state) => state.threadListItem.id));
  return Number.isInteger(id) && id > 0 ? id : null;
}
